import React from "react";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {Link, withRouter} from "react-router-dom";
import PropTypes from "prop-types";
import InfiniteScroll from "react-infinite-scroller";
import {getRelatives} from "../members/actions/relativesAction";
import {ROUTER_IMAGE, ROUTER_VIDEO} from "../../shared/constants/routers";
import {getSeniors} from "../members/actions/seniorsAction";
import {loadMore} from "./actions/timelineAction";
import AuthLayout from "../../shared/containers/AuthLayout";
import TimelineItemBody from "./components/TimelineItemBody";
import TimelineItemHeader from "./components/TimelineItemHeader";
import TimelineItem from "./components/TimelineItem";


class Timeline extends React.Component {

  static propTypes = {
    timeline: PropTypes.array,
    seniors: PropTypes.array,
    hasMore: PropTypes.bool,
    loadMore: PropTypes.func
  };

  static defaultProps = {
    timeline: [],
    seniors: [],
    hasMore: true
  };

  componentDidMount() {
    this.props.dispatch(getSeniors())
      .then((seniors) => {
        if (this.props.timeline.length === 0) {
          this.props.dispatch(loadMore(1));
        }
        this.props.dispatch(getRelatives(seniors))
      });
  }

  render() {
    const list = this.props.timeline.map((obj, index) => {
      return (
        <TimelineItem type={obj.type} recipient={obj.recipient} key={index}>
          <TimelineItemHeader
            recipient={obj.recipient}
            sender={obj.sender}
            type={obj.type}
            date={obj.date}
          />
          <TimelineItemBody
            recipient={obj.recipient}
            feedback={obj.feedback}
            rights={obj.rights}
            title={obj.title}
            image={obj.image}
          />
        </TimelineItem>
      );
    });

    return (
      <AuthLayout title={__("Welcome to the Family Portal")}
                  description={__("What do you want to do?")}
      >
        <div className="subtitleContainer">
          <div className="flexBox direction-column flex">
            <Link className="buttonPrimary" to={ROUTER_IMAGE}>
              <i className="fa fa-camera"/>{__("Send a picture")}
            </Link>
            <Link className="buttonPrimary" to={ROUTER_VIDEO}>
              <i className="fa fa-video-camera"/>{__("Start a video call")}
            </Link>
          </div>
        </div>
        <div id="timeline">
          <InfiniteScroll
            pageStart={1}
            loadMore={this.props.loadMore}
            hasMore={this.props.hasMore}
            useWindow={true}
            initialLoad={false}
            loader={
              <div className="loader">
                <div className="login-icon">
                  <i className="fa fa-spinner fa-spin fa-2x fa-fw"/>
                </div>
              </div>
            }
          >
            {list}
          </InfiniteScroll>
        </div>
      </AuthLayout>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    timeline: state.timeline.items,
    seniors: state.seniors,
    hasMore: state.timeline.hasMore
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    { loadMore: loadMore },
    dispatch
  );
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Timeline));
